import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LinkService {
 private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  addAlternateLink(hrefLang: string, href: string): void {
    const link: HTMLLinkElement = this.renderer.createElement('link');
    this.renderer.setAttribute(link, 'rel', 'alternate');
    this.renderer.setAttribute(link, 'hreflang', hrefLang);
    this.renderer.setAttribute(link, 'href', href);

    // Remove any existing link with same hreflang
    const existing = this.document.head.querySelector(`link[rel="alternate"][hreflang="${hrefLang}"]`);
    if (existing) {
      this.renderer.removeChild(this.document.head, existing);
    }

    this.renderer.appendChild(this.document.head, link);
  }

  clearAlternateLinks(): void {
    const links = this.document.head.querySelectorAll('link[rel="alternate"]');
    links.forEach(link => this.renderer.removeChild(this.document.head, link));
  }
}
